module.exports = __webpack_public_path__ + "img/policy.08fba6bd.png";